
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DocumentSummary } from "../../../domain/document";

@Component
export default class DocumentListViewMixin extends Mixins() {
  @Prop({ default: "" })
  presetFilterKey: string;

  data(): any {
    return {
      selectedDocument: null as DocumentSummary,
    };
  }
  selectedDocument: DocumentSummary;

  showSpecifiedDocument(summary: DocumentSummary, archiveId: number): void {
    if (!summary || !summary.isReadable) {
      return;
    }
    this.$logger.info("文書を参照します。");

    // 別Windowで開く.(完全SPAにするとメモリリーク発生による問題が顕在化しやすくなる恐れがあるため.)
    this.$openWindow(
      "/ShowDocument",
      {
        patientNo: summary.patientNo,
        documentId: summary.id.toString(),
        archiveId: (archiveId != null) ? archiveId.toString() : undefined,
        isReadRestrictionAlreadyHandled: true.toString(),
      }
    );
  }
}
